import React from 'react';

import {SettingsSection} from '~src/settings/components/common/SettingsSection';
import {componentRegistryEntry} from '~src/settings/general-settings/components/SettingsComponentRegistryFunctions';
import {IPrivateConnectRegionIamRole} from '~src/settings/privateconnect-settings/PrivateConnectSettings';
import {SitePrivateConnectSettingsForSiteAdminProps} from '~src/settings/privateconnect-settings/PrivateConnectSettingsCoordinator';
import {UserSettingsStyle} from '~src/userSettings/styles/UserSettingsStyle';

export function PrivateConnectAwsRegionsSection(props: SitePrivateConnectSettingsForSiteAdminProps) {
  let fakeRow1: IPrivateConnectRegionIamRole = {
    region: 'ap-south-1',
    iamRole: 'arn:aws:iam::452864042326:role/pvtconn-outbound-dp001-private-connect'
  };
  let fakeRow2: IPrivateConnectRegionIamRole = {
    region: 'eu-north-1',
    iamRole: 'arn:aws:iam::444930465512:role/pvtconn-outbound-dp001-private-connect'
  };
  let fakeRow3: IPrivateConnectRegionIamRole = {
    region: 'eu-west-3',
    iamRole: 'arn:aws:iam::452864042326:role/pvtconn-outbound-dp001-private-connect'
  };
  let fakeRow4: IPrivateConnectRegionIamRole = {
    region: 'eu-south-1',
    iamRole: 'arn:aws:iam::076413871786:role/pvtconn-outbound-dp001-private-connect'
  };
  let fakeRow5: IPrivateConnectRegionIamRole = {
    region: 'us-east-1',
    iamRole: 'arn:aws:iam::412600517540:role/pvtconn-outbound-dp001-private-connect'
  };
  let fakeRow6: IPrivateConnectRegionIamRole = {
    region: 'ap-south-1',
    iamRole: 'arn:aws:iam::452864042326:role/pvtconn-outbound-dp001-private-connect'
  };
  let fakeRow7: IPrivateConnectRegionIamRole = {
    region: 'us-west-2',
    iamRole: 'arn:aws:iam::209035882792:role/pvtconn-outbound-dp001-private-connect'
  };

  let privateConnectRegionIamRoles: Array<IPrivateConnectRegionIamRole> = [];
  privateConnectRegionIamRoles.push(fakeRow1);
  privateConnectRegionIamRoles.push(fakeRow2);
  privateConnectRegionIamRoles.push(fakeRow3);
  privateConnectRegionIamRoles.push(fakeRow4);
  privateConnectRegionIamRoles.push(fakeRow5);
  privateConnectRegionIamRoles.push(fakeRow6);
  privateConnectRegionIamRoles.push(fakeRow7);

  return (
    <SettingsSection title='IAM Roles'>
      <div className="tb-user-settings-item-table">
        <table className="tb-static-grid-table">
          <tbody>
          <tr>
            <th className={UserSettingsStyle.tableHeaderLine}>
              <span className="tb-data-grid-header-text">
                Region
              </span>
            </th>
            <th className={UserSettingsStyle.tableHeaderLine}>
              <span className="tb-data-grid-header-text">
                IAM Role
              </span>
            </th>
          </tr>
          {privateConnectRegionIamRoles.map((privateConnectRegionIamRole, index) => {
            return (
              <tr key={index} data-tb-test-id='pat-list-item'>
                <td className={UserSettingsStyle.tableMultilineWithSeparatorRow}>
                  <div className="tb-data-grid-cell-text">
                    <span className={UserSettingsStyle.itemTableName}>
                      {privateConnectRegionIamRole.region}
                    </span>
                  </div>
                </td>
                <td className={UserSettingsStyle.tableMultilineWithSeparatorRow}>
                  <div className="tb-data-grid-cell-text">
                    <span className={UserSettingsStyle.itemTableName}>
                      {privateConnectRegionIamRole.iamRole}
                    </span>
                  </div>
                </td>
              </tr>
            );
          })}
          </tbody>
        </table>
      </div>

    </SettingsSection>
  );
}

export const PrivateConnectAwsRegionsSectionSpecs = componentRegistryEntry({
  name: 'PrivateConnectAwsRegionsSection',
  component: PrivateConnectAwsRegionsSection
});